import React, { useCallback } from 'react';

export const ReviewMessage = (props: { percentage: string }) => {
  const { percentage } = props;

  const getMessage = useCallback(() => {
    const _percentage = parseInt(percentage);
    switch (true) {
      case _percentage === 100:
        return 'Kundservice i världsklass!';
      case _percentage < 100 && _percentage >= 95:
        return 'Ni är ju fantastiska!';
      case _percentage < 95 && _percentage >= 90:
        return 'Så nära målet!';
      case _percentage < 90 && _percentage >= 85:
        return 'Tappa inte farten nu!';
      case _percentage < 85 && _percentage >= 75:
        return 'Kämpa vidare, ni kan det här!';
      case _percentage < 75 && _percentage >= 50:
        return 'Åh nej, många kunder får vänta!';
      default:
        return 'Nu kan det bara bli bättre!';
    }
  }, [percentage]);

  return (
    <strong>
      <i>{getMessage()}</i>
    </strong>
  );
};
